import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Form, Select } from 'antd';
import LabeledTooltip from '../LabeledTooltip';
var insurancePlanRules = function (member_id, hasMedicalCare) { return [
    {
        required: !!member_id,
        validator: function (rule, value) {
            var isValid = value !== undefined || !member_id || !hasMedicalCare;
            if (isValid)
                return Promise.resolve();
            return Promise.reject(new Error('Select Insurance Plan To Attach This Doctor'));
        }
    }
]; };
var InsurancePlan = function (_a) {
    var form = _a.form, member_id = _a.member_id, loading = _a.loading, insuranceOptions = _a.insuranceOptions, insuranceSelected = _a.insuranceSelected, setInsuranceSelected = _a.setInsuranceSelected, hasMedicalCare = _a.hasMedicalCare, tooltipText = _a.tooltipText;
    return (_jsx(Form.Item, { name: "insurance_plan", "data-test": "costEstimationFormInsurancePlanSelect", rules: insurancePlanRules(member_id, hasMedicalCare), label: _jsx(LabeledTooltip, { label: "Insurance Plan", tooltipText: tooltipText }), labelAlign: "left", colon: false, children: _jsx(Select, { placeholder: "Select Plan", loading: loading, disabled: loading, value: insuranceSelected, onChange: function (item) {
                setInsuranceSelected(item);
                form.setFieldsValue({ insurance_tier_id: undefined });
            }, options: insuranceOptions }) }));
};
export default InsurancePlan;
